<template>
  <div>
    <v-dialog class="paper-dialog" title="Create a New Paper" :visible.sync="dialogVisible" width="65vw" @open="onOpen"
      @close="onClosed">
      <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" label-width="150px">
        <el-form-item label="SE/CE" prop="seId">
          <el-select placeholder="Please select SE/CE" v-model="form.seId">
            <el-option v-for="(item, index) in seList" :label="item.Name" :value="item.SEID" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="Content Category" prop="categoryId">
          <el-select placeholder="Please select content category" v-model="form.categoryId">
            <el-option v-for="(item, index) in categoryList" :label="item.CategoryName" :value="item.PaperCategoryID"
              :key="index">
              <div class="select-option-item" :title="item.CategoryName">
                {{ item.CategoryName }}
              </div>
            </el-option>
          </el-select>
          <el-button icon="el-icon-plus" @click="showCateDialog" />
        </el-form-item>
        <el-form-item label="Short Title" prop="shortTitle">
          <el-input placeholder="Please input short title" v-model="form.shortTitle" maxlength="100" />
        </el-form-item>
        <el-form-item label="Search Term" prop="searchTerm">
          <el-input placeholder="Please input search term" v-model="form.searchTerm" maxlength="100" />
        </el-form-item>
        <el-form-item label="Upload PDF">
          <el-upload :action="action" :headers="headers" :on-preview="handlePreview" :on-success="handleSuccess"
            :on-exceed="handleExceed" :limit="1" :file-list="fileList" accept=".PDF,.pdf">
            <el-button icon="el-icon-plus"> Choose File </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="Content" prop="paperContent" class="editor">
          <TinymceEditor v-model="form.paperContent" :height="300" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="push-footer">
        <el-button type="primary" @click="onSubmit"> Submit </el-button>
        <el-button plain @click="onClosed"> Cancel </el-button>
      </div>
    </v-dialog>
    <NewCategoryDialog :visible.sync="addCategoryDialogVisible" @success="onNewCateSuccess" @closed="onNewCateClosed" />
  </div>
</template>
<script>
import TinymceEditor from "../../components/tinymce-editor";
import NewCategoryDialog from "./new-category-dialog.vue";
import { trimValidate } from "../../utils/validator";
export default {
  name: "new-paper-dialog",
  components: { TinymceEditor, NewCategoryDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      seList: [],
      categoryList: [],
      form: {
        seId: "",
        categoryId: "",
        shortTitle: "",
        searchTerm: "",
        isReplace: false,
        paperContent: "",
      },
      formRules: {
        seId: [
          { required: true, message: "Please select SE/CE", trigger: "change" },
        ],
        categoryId: [
          {
            required: true,
            message: "Please select content category",
            trigger: "change",
          },
        ],
        shortTitle: [
          {
            required: true,
            validator: trimValidate("Please input short title"),
            trigger: "blur",
          },
        ],
        searchTerm: [
          {
            required: true,
            validator: trimValidate("Please input search term"),
            trigger: "blur",
          },
        ],
        fileName: [
          { required: true, message: "it must be filled", trigger: "blur" },
        ],
        uploadName: [
          { required: true, message: "it must be filled", trigger: "blur" },
        ],
      },
      hidePaperDialog: false,
      addCategoryDialogVisible: false,
      fileList: [],
      previewUrl: "",
      previewName: "",
    };
  },
  computed: {
    action() {
      return `${process.env.VUE_APP_SERVER_API}/content/uploadFile`;
    },
    headers() {
      return { Authorization: this.$store.state.token };
    },
    fileName() {
      return this.fileList.length === 1 ? this.fileList[0].name : null;
    },
    uploadName() {
      return this.fileList.length === 1 ? this.fileList[0].fileNameSave : null;
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {
    onClosed() {
      if (!this.hidePaperDialog) {
        this.fileList = [];
        this.$refs.form.resetFields();
        this.$emit("update:visible", false);
      }
    },
    onOpen() {
      this.getSEList();
      this.getCategoryList();
      if (this.data && !this.hidePaperDialog) {
        this.$nextTick(() => {
          const {
            SEID,
            PaperCategoryID,
            ShortTitle,
            SearchTerm,
            PaperContent,
            Attachment,
          } = this.data;
          this.form.seId = SEID;
          this.form.categoryId = PaperCategoryID;
          this.form.shortTitle = ShortTitle;
          this.form.searchTerm = SearchTerm;
          this.form.paperContent = PaperContent;
          this.previewUrl = `/upload/paper/${Attachment}`;
        });
      }
      if (this.hidePaperDialog) {
        this.hidePaperDialog = false;
      }
    },
    getSEList() {
      this.axios.get("/content/seList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.seList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    getCategoryList() {
      this.axios.get("/content/categoryList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.categoryList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    onSubmit() {
      this.axios
        .post("/content/addPaper", {
          ...this.form,
          shortTitle: this.form.shortTitle.trim(),
          searchTerm: this.form.searchTerm.trim(),
          fileName: this.fileName,
          uploadName: this.uploadName,
        })
        .then(({ code, msg }) => {
          if (code == 200) {
            this.$message.success("Create meeting content successfully");
            this.$emit("success");
            this.$emit("update:visible", false);
          } else {
            this.$message.error(msg);
          }
        });
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.href = file.fileUrl;
      a.target = "blank";
      a.click();
    },
    handleExceed() {
      this.$message.warning(`最多只能上传1个pdf文件`);
    },
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.fileList = [];
        this.fileList.push({
          name: file.name,
          fileNameSave: res.data.fileNameSave,
          fileUrl: res.data.url,
          // fileUrl: `/online-preview/${res.data..code}`,
        });
        this.$message.success("Upload file successfully");
      } else {
        this.$message.error("Upload file failed");
      }
    },
    showCateDialog() {
      this.hidePaperDialog = true;
      this.dialogVisible = false;
      this.addCategoryDialogVisible = true;
    },
    onNewCateSuccess(categoryId) {
      this.getCategoryList();
      this.form.categoryId = categoryId;
    },
    onNewCateClosed() {
      this.hidePaperDialog = false;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-dialog {
  ::v-deep .el-dialog__body {
    padding: 15px;
    display: flex;
    max-height: 70vh;
  }
}

::v-deep {
  .select-option-item {
    max-width: 25vw;
  }
}

.el-select+.el-button {
  margin-left: 10px;
}

.push-footer {
  text-align: center;
}

.el-form-item {
  margin-bottom: 15px !important;

  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }

  &.replace-file {
    ::v-deep {
      .el-form-item__content {
        display: flex;
      }
    }
  }

  &.editor {
    margin-bottom: 0 !important;
  }
}

.replace-file-tip {
  span {
    margin: 0 10px;
  }
}
</style>
